module.exports = __webpack_public_path__ + "static/img/5.26b566a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news15/5.png
// module id = 4gcn
// module chunks = 1